import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=4e156db2&scoped=true&"
import script from "./edit1.vue?vue&type=script&lang=js&"
export * from "./edit1.vue?vue&type=script&lang=js&"
import style0 from "./edit1.vue?vue&type=style&index=0&id=4e156db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e156db2",
  null
  
)

export default component.exports